// Espera a que Supabase restaure la sesión del localStorage antes de
// permitir que los middlewares corran. Sin esto, al refrescar la página
// useSupabaseUser() es null por un momento y el middleware redirige al login.
export default defineNuxtPlugin(async () => {
  const supabase = useSupabaseClient()
  await supabase.auth.getSession()
})
